// src/Components/Dashboard/ActionButtons.jsx
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from "@/Components/ui/button";
import { Send, QrCode } from "lucide-react";

const ActionButtons = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleFeedbackClick = () => {
        navigate('/feedback');
    };

    const handleQRCodeClick = () => {
        navigate('/qr-code');
    };

    return (
        <div className="space-y-4 mb-8 mt-[50px]">
            <div className="text-center space-y-6">
                <Button
                    className="w-full bg-ps-blue-dark hover:bg-blue-600 text-white w-80 h-[50px] mb-10 transition-all duration-200 hover:shadow-lg"
                    onClick={handleFeedbackClick}
                >
                    <Send className="mr-2" size={20} />
                    {t('dashboard.sendFeedback')}
                </Button>
                &nbsp;
                <Button
                    className="w-full bg-ps-orange hover:opacity-75 text-white w-80 h-[50px] mb-10 transition-all duration-200 hover:shadow-lg"
                    onClick={handleQRCodeClick}
                >
                    <QrCode className="mr-2" size={20} />
                    {t('dashboard.generateQR')}
                </Button>
            </div>
        </div>
    );
};

export default ActionButtons;